import { isEmpty } from 'lodash';

import { TableEmptyState } from '@/components/tables/DataTable/TableEmptyState';

import { CreateClientButton } from './ClientListPage.components';
import { getFilterVariables } from './ClientListPage.utils';
import type { ClientSearchFilterType } from './ClientSearchFilterToolbar/ClientSearchFilterToolbar.types';

export interface ClientListEmptyStateProps {
  searchString: string;
  filterValue: Record<ClientSearchFilterType, string[]>;
  onCreateClient: () => void;
}

export function ClientListEmptyState({
  searchString,
  filterValue,
  onCreateClient,
}: ClientListEmptyStateProps) {
  const getEmptyStateText = () => {
    const filterVariables = getFilterVariables(filterValue);
    if (searchString) {
      return `No clients found for "${searchString}"`;
    } else if (!isEmpty(filterVariables)) {
      return `No clients found with active filters`;
    }

    return 'No clients';
  };

  return (
    <TableEmptyState text={getEmptyStateText()}>
      {!searchString && isEmpty(getFilterVariables(filterValue)) && (
        <CreateClientButton onClick={onCreateClient} />
      )}
    </TableEmptyState>
  );
}
